import { apiUrl } from '../utils/api-url';

/**
 * A GMS capability from the canonical Capability Registry
 * (`config/capability-registry.json`). The Audit Navigator capability map
 * bridges documents → capabilities → controls: `controlReferences` is the
 * join key against a document's `auditControls`.
 */
export interface Capability {
  id: string;
  name: string;
  description: string;
  domain: string;
  minPlan: number;
  controlReferences: string[];
}

export async function listCapabilities(token: string): Promise<Capability[]> {
  const res = await fetch(apiUrl('/api/capabilities'), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to list capabilities: ${res.status}`);
  return res.json();
}
